import { GetUser } from "../../utils/sessions";

export const buildParameter = {
         SaveDetail: (id, formdata) => {
           let param = {
             ROLE_ID: id,
             ROLE_DESC: formdata.ROLE_DESC,
             ACTIVE: formdata.ACTIVE,
             SESSION_OWNER: GetUser(),
           };
           return param;
         },
       };
